// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".emojy-box span[data-v-1a8fa250]{display:block;max-width:280px;word-wrap:break-word}", ""]);
// Exports
module.exports = exports;
